// screens/LoadingScreen.js
// PrizeReal — Pantalla de carga inicial (mientras Firebase resuelve el auth)

import React, { useEffect, useState } from "react";
import "./LoadingScreen.css";

const LoadingScreen = () => {
  const [visible, setVisible] = useState(false);

  // Fade-in leve para evitar flash brusco
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={`loading-screen ${visible ? "loading-screen--visible" : ""}`} role="status" aria-label="Cargando PrizeReal">
      <div className="loading-screen__inner">
        {/* Logo / wordmark */}
        <div className="loading-screen__logo" aria-hidden="true">
          
          <span className="loading-screen__logo-in">Prize</span>
          <span className="loading-screen__logo-app">Real</span>
        </div>

        {/* Tagline */}
        <p className="loading-screen__tagline">
          Share local. Show up. Get rewarded.
        </p>

        {/* Spinner */}
        <div className="loading-screen__spinner-wrap">
          <span className="loading-screen__spinner" />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
